import { default as _91_46_46_46slug_939jGjnmqyXzMeta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[...slug].vue?macro=true";
import { default as orders4uNxcOTzYyMeta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/orders.vue?macro=true";
import { default as profilezdJpIXdLN6Meta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/profile.vue?macro=true";
import { default as wishlistsGoU8louBGBMeta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/wishlists.vue?macro=true";
import { default as createCartKK7ouzrXSLMeta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/createCart.vue?macro=true";
import { default as payment_45returnPwAC2pIKewMeta } from "/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/payment-return.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_939jGjnmqyXzMeta?.name ?? "slug",
    path: _91_46_46_46slug_939jGjnmqyXzMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_939jGjnmqyXzMeta || {},
    alias: _91_46_46_46slug_939jGjnmqyXzMeta?.alias || [],
    redirect: _91_46_46_46slug_939jGjnmqyXzMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: orders4uNxcOTzYyMeta?.name ?? "lang-account-orders",
    path: orders4uNxcOTzYyMeta?.path ?? "/:lang?/account/orders",
    meta: orders4uNxcOTzYyMeta || {},
    alias: orders4uNxcOTzYyMeta?.alias || [],
    redirect: orders4uNxcOTzYyMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/orders.vue").then(m => m.default || m)
  },
  {
    name: profilezdJpIXdLN6Meta?.name ?? "lang-account-profile",
    path: profilezdJpIXdLN6Meta?.path ?? "/:lang?/account/profile",
    meta: profilezdJpIXdLN6Meta || {},
    alias: profilezdJpIXdLN6Meta?.alias || [],
    redirect: profilezdJpIXdLN6Meta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/profile.vue").then(m => m.default || m)
  },
  {
    name: wishlistsGoU8louBGBMeta?.name ?? "lang-account-wishlists",
    path: wishlistsGoU8louBGBMeta?.path ?? "/:lang?/account/wishlists",
    meta: wishlistsGoU8louBGBMeta || {},
    alias: wishlistsGoU8louBGBMeta?.alias || [],
    redirect: wishlistsGoU8louBGBMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/account/wishlists.vue").then(m => m.default || m)
  },
  {
    name: createCartKK7ouzrXSLMeta?.name ?? "lang-createCart",
    path: createCartKK7ouzrXSLMeta?.path ?? "/:lang?/createCart",
    meta: createCartKK7ouzrXSLMeta || {},
    alias: createCartKK7ouzrXSLMeta?.alias || [],
    redirect: createCartKK7ouzrXSLMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/createCart.vue").then(m => m.default || m)
  },
  {
    name: payment_45returnPwAC2pIKewMeta?.name ?? "lang-payment-return",
    path: payment_45returnPwAC2pIKewMeta?.path ?? "/:lang?/payment-return",
    meta: payment_45returnPwAC2pIKewMeta || {},
    alias: payment_45returnPwAC2pIKewMeta?.alias || [],
    redirect: payment_45returnPwAC2pIKewMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/81023597/pages/[[lang]]/payment-return.vue").then(m => m.default || m)
  }
]